import React from 'react'
import { connect } from 'react-redux'
import {Field, formValueSelector, reduxForm} from 'redux-form'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faRedo} from "@fortawesome/free-solid-svg-icons";

let BridgeForm = props => {
  const { handleSubmit, reset, submitting, onPrevious, useOptionalFieldsValue, useCreditCardValue, paymentDetailsValue, creditCardCofContratTypeSelected } = props;

  return (
    <div>
      <h3>Widget as a Bridge</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="merchantId">Merchant ID</label>
          <Field className="form-control" name="merchantId" component="input" type="text" disabled={true}/>
        </div>
        <div className="form-group">
          <label htmlFor="orderId">Language</label>
          <Field className="form-control" name="language" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="layout">Layout</label>
          <Field className="form-control" name="layout" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="orderId">
            Products (comma "," separated). Leave empty for all products <br />
            <small>Options: 'creditcard', 'sepa', 'paypal'</small>
          </label>
          <Field className="form-control" name="products" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="customStyleId">Custom style id</label>
          <Field className="form-control" name="customStyleId" component="input" type="text" />
        </div>

        <div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field name="hidePayButton" component="input" type="checkbox" /> <b>Hide Pay Button</b>
              </label>
            </div>
          </div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field component="input" name="hideTitleIcons" type="checkbox" /> <b>Hide Title Icons</b>
              </label>
            </div>
          </div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field component="input" name="skipFinalResultView" type="checkbox" /> <b>Skip final result view</b>
              </label>
            </div>
          </div>
        </div>


        <div>
          <h3>Optional parameters:</h3>
          <hr/>
          <div className="form-group">
              <div className="checkbox">
                  <label>
                      <Field component="input" name="optionalFields" type="checkbox" /> <b>Use optional fields</b>
                  </label>
              </div>
          </div>
          {useOptionalFieldsValue && <div className="form-group">
            <h4>Credit card:</h4>
            <div className="form-group">
                <div className="checkbox">
                    <label>
                        <Field component="input" name="useCreditCard" type="checkbox" /> <b>Use credit card</b>
                    </label>
                </div>
            </div>
            {useCreditCardValue && <div className="form-group">
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field component="input" name="creditCard.cardHolder" type="checkbox" /> <b>Card holder</b>
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field component="input" name="creditCard.cvcNeeded" type="checkbox" /> <b>Create Payment Instrument with CVC</b>
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="dropdown">
                    <div>
                        <label htmlFor="creditCard.cofContract.type">COF Contract Type</label>
                    </div>
                    <Field component="select" name="creditCard.cofContract.type">
                        <option value="">Select type</option>
                        <option value="ONECLICK">ONECLICK</option>
                        <option value="UNSCHEDULED">UNSCHEDULED</option>
                        <option value="SCHEDULED">SCHEDULED</option>
                    </Field>
                </div>
              </div>

              {useCreditCardValue && creditCardCofContratTypeSelected === 'SCHEDULED' && <div>
                <div className="form-group">
                  <label htmlFor="creditCard.cofContract.recurringExpiry">COF Recurring Expiry</label>
                  <Field className="form-control" name="creditCard.cofContract.recurringExpiry" component="input" type="text"/>
                </div>
                <div className="form-group">
                  <label htmlFor="creditCard.cofContract.recurringFrequency">COF Recurring Frequency</label>
                  <Field className="form-control" name="creditCard.cofContract.recurringFrequency" component="input" type="text"/>
                </div>
              </div>}


            </div>}
            <h4>Sepa:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="sepa.bic" type="checkbox" /> <b>BIC</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="sepa.bankName" type="checkbox" /> <b>Bank Name</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="sepa.requestMandate" type="checkbox" /> <b>Mandate</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="dropdown">
                <div>
                  <label htmlFor="sepa.directDebitType">Direct Debit Type</label> <br />
                  <small>Options: 'SINGLE', 'FIRST'</small>
                </div>
                <Field className="form-control" component="input" name="sepa.directDebitType" type="text"/>
              </div>
            </div>

            <div>
              <h3>Payment Details:</h3>
              <hr/>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="paymentDetailsUsage.general" component="input" type="checkbox"/> <b>Use Payment Details</b>
                  </label>
                </div>
              </div>
              {paymentDetailsValue && paymentDetailsValue.general && <div>
                <h4>PayPal:</h4>
                <div className="form-group">
                  <div className="checkbox">
                    <label>
                      <Field name="paymentDetailsUsage.paypal.general" component="input" type="checkbox"/> <b>PayPal</b>
                    </label>
                  </div>
                </div>
                {paymentDetailsValue && paymentDetailsValue.paypal && paymentDetailsValue.paypal.general && <div>
                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <Field name="paymentDetailsUsage.paypal.returnUrl" component="input" type="checkbox"/> <b>Return Url</b>
                      </label>
                    </div>
                  </div>
                  {paymentDetailsValue && paymentDetailsValue.paypal && paymentDetailsValue.paypal.returnUrl && <div>
                    <div className="form-group">
                      <label htmlFor="paymentDetails.wechatPay.countryCode">Return url</label>
                      <Field className="form-control" name="paymentDetails.paypal.returnUrl" component="input" type="text"/>
                    </div>
                  </div>}

                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <Field name="paymentDetailsUsage.paypal.cancelUrl" component="input" type="checkbox"/> <b>Cancel Url</b>
                      </label>
                    </div>
                  </div>
                  {paymentDetailsValue && paymentDetailsValue.paypal && paymentDetailsValue.paypal.cancelUrl && <div>
                    <div className="form-group">
                      <label htmlFor="paymentDetails.paypal.cancelUrl">Cancel url</label>
                      <Field className="form-control" name="paymentDetails.paypal.cancelUrl" component="input" type="text"/>
                    </div>
                  </div>}

                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <Field name="paymentDetailsUsage.paypal.notifyUrl" component="input" type="checkbox"/> <b>Notify Url</b>
                      </label>
                    </div>
                  </div>
                  {paymentDetailsValue && paymentDetailsValue.paypal && paymentDetailsValue.paypal.notifyUrl && <div>
                    <div className="form-group">
                      <label htmlFor="paymentDetails.paypal.notifyUrl">Notify url</label>
                      <Field className="form-control" name="paymentDetails.paypal.notifyUrl" component="input" type="text"/>
                    </div>
                  </div>}
                </div>}
              </div>}
            </div>





          </div>}
        </div>

        <div className="hr-line-dashed"></div>
        <div className="form-group m-b-none container-buttons">
          <div className="col-xs-12 container-buttons">
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs container-button">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={onPrevious}>
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className="btn-text">Previous</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 text-center m-b-xs container-button">
              <button type="button" className="btn btn-primary2 col-xs-12" disabled={submitting} onClick={reset}>
                <FontAwesomeIcon icon={faRedo} />
                <span className="btn-text">Reset</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs container-button">
              <button type="submit" className="btn btn-primary col-xs-12">
                <span className="btn-text">Init Widget as a Bridge</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

BridgeForm = reduxForm({
  form: 'bridge'
})(BridgeForm);

const selector = formValueSelector('bridge');

BridgeForm = connect(
  state => {
    const initialValues = {
      merchantId: state.config.environment.merchantId,
      language: 'en',
      products: null,
      layout: 'dropdown',
      customStyleId: null,
      hidePayButton: false,
      hideTitleIcons: false,
      skipFinalResultView: true,
      paymentDetailsUsage: {
        general: true,
        paypal: {
          general: true,
          returnUrl: true,
          cancelUrl: true,
          notifyUrl: false,
          confirmUrl: false
        },
      },
      paymentDetails: {
        paypal: {
          returnUrl: 'http://return.url',
          cancelUrl: 'http://cancel.url',
          notifyUrl: 'http://notify.url',
          confirmUrl: 'http://confirm.url'
        },
      },
      optionalFields: true,
      creditCard: {
        cardHolder: true,
        cvcNeeded: true,
        cofContract: {
          type: null,
          recurringExpiry: '2020-08-01',
          recurringFrequency: 30
        }
      },
      sepa: {
        bankName: true,
        bic: true,
        directDebitType: 'SINGLE',
        requestMandate: false
      },
      paypal: {
        returnUrl: null,
        cancelUrl: null,
        notifyUrl: null,
        confirmUrl: null
      }
    };
    return {
      initialValues,
      useOptionalFieldsValue: selector(state, 'optionalFields'),
      useCreditCardValue: selector(state, 'useCreditCard'),
      refTransactionValue: selector(state, 'refTransaction'),
      paymentDetailsValue: selector(state, 'paymentDetailsUsage'),
      creditCardCofContratTypeSelected: selector(state, 'creditCard.cofContract.type')
    };
  }
)(BridgeForm);

export default BridgeForm



// WEBPACK FOOTER //
// ./src/bridge/BridgeForm.js